import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20elegant%20modern%20beauty%20salon%20interior%20with%20soft%20rose%20and%20cream%20color%20palette%2C%20young%20asian%20female%20students%20enjoying%20hair%20styling%20and%20makeup%20services%2C%20large%20windows%20with%20natural%20light%2C%20minimalist%20aesthetic%20design%20with%20plants%2C%20editorial%20photography%2C%20warm%20atmosphere%2C%20clean%20and%20sophisticated&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        alt="女大学生的沙龙室 - 温暖优雅的美容空间"
        title="女大学生的沙龙室 - 专属美发美妆体验空间"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45" />

      <div className="absolute inset-0 flex items-center justify-center w-full">
        <div className="w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white font-bold leading-tight text-balance">
            女大学生的
            <br className="md:hidden" />
            专属<span className="text-accent-300">美丽空间</span>
          </h1>
          <p className="mt-4 md:mt-6 text-sm md:text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
            专为在校女大学生打造的美发、美妆与美容体验空间，
            平价时尚，让美丽触手可及
          </p>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/services"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap cursor-pointer transition-all duration-200"
            >
              探索服务项目
            </Link>
            <Link
              to="/about"
              className="border border-white/60 hover:border-white text-white hover:bg-white/10 px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap cursor-pointer transition-all duration-200"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}